import {
  makeStyles,
  Select,
  SelectProps,
  useId,
  Label,
} from "@fluentui/react-components";
import { FieldValues } from "react-hook-form";

export type AppSelectOptionEntry = { value: string; label: string; disabled?: boolean };

interface IAppUserSelect {
  label: string;
  options?: string[];
  /** Options with separate value (e.g. id) and label. When set, it takes precedence over `options`. */
  optionEntries?: AppSelectOptionEntry[];
  formHandler: FieldValues;
}

const useStyles = makeStyles({
  root: {
    width: "150px",
  },
});

export default function AppSelect(props: IAppUserSelect & SelectProps) {
  const styles = useStyles();
  const dropdownId = useId("select");
  const { label, options = [], optionEntries, formHandler, ...rest } = props;

  return (
    <div>
      <Label id={dropdownId}>{label}</Label>
      <Select
        aria-labelledby={dropdownId}
        className={styles.root}
        {...formHandler}
        {...rest}
      >
        {optionEntries
          ? optionEntries.map((o) => (
              <option key={o.value || o.label} value={o.value} disabled={o.disabled}>
                {o.label}
              </option>
            ))
          : options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
      </Select>
    </div>
  );
}
